import axios from "axios";

const EMPRESA_URL =
  `${process.env.REACT_APP_API_URL}/data_validade` ||
  "http://localhost:3001/api/data_validade";

export async function getDataValidade(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(EMPRESA_URL, { headers });
  return response.data;
}
